import React from 'react'
import { observer } from 'mobx-react'
import {
  Dialog,
  DialogButton,
  DialogButtonGroup,
  DialogDescription,
  DialogFooter,
  DialogFooterSpacer,
  DialogHeader,
  DialogIllustration,
  DialogTitle,
} from '../../../components/Dialog'
import { IgnoreMergeRequestDialogViewModel } from './IgnoreMergeRequestDialogViewModel'

interface Props {
  vm: IgnoreMergeRequestDialogViewModel
}

export default observer(function IgnoreMergeRequestDialog({ vm }: Props) {
  return (
    <Dialog showing={vm.showing} onClose={vm.close}>
      <DialogHeader bordered>
        <DialogIllustration
          src={require('assets/images/img_confirm-action.svg')}
          alt="Illustration of a confused person with a question mark bubble above their head"
        />
        <DialogTitle>You're about to ignore this merge request</DialogTitle>
        <DialogDescription>
          <strong>{vm.customerDisplayName}</strong>'s merge request will be
          removed from the list and ignored. They will not be notified and no
          action will be taken against their accounts.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter bordered>
        <DialogFooterSpacer />
        <DialogButtonGroup>
          <DialogButton disabled={vm.ignore.pending} onClick={vm.close}>
            Close
          </DialogButton>
          <DialogButton
            disabled={vm.ignore.pending}
            type="danger"
            onClick={vm.ignore}
            loading={vm.ignore.pending}
          >
            Ignore Request
          </DialogButton>
        </DialogButtonGroup>
      </DialogFooter>
    </Dialog>
  )
})
